import { render, staticRenderFns } from "./FbUpdateCodecCompanyName.vue?vue&type=template&id=830fc7f4"
import script from "./FbUpdateCodecCompanyName.vue?vue&type=script&lang=ts"
export * from "./FbUpdateCodecCompanyName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports